import { Injectable } from "@angular/core";
import { HttpService } from "src/providers/http.service";

@Injectable({
    providedIn: "root"
})
export class UserTypeModel {
    private userType = {
        _id: undefined,
        type: undefined,
        description: undefined,
        rolesRef: [],
        formRef: []
    };

    private fields = [];
    private dataNext = [];
    constructor(
        private http: HttpService
    ) { }

    set(data: any) {
        console.log("set ========================> ", data);
        return new Promise((resolve, reject) => {
            this.userType = {
                _id: data._id,
                type: data.type,
                description: data.description,
                rolesRef: data.rolesRef,
                formRef: data.formRef
            };
            resolve(this.userType);
        }).catch(err => console.log("Error trying to set new user type: ", err));
    }

    get() {
        return this.userType;
    }

    getAll(data: any = {}) {
        return new Promise((resolve, reject) => {
            this.http.post("api/user-types/user-types/getAll", true, data).then(res => {
                resolve(res);
            }).catch(err => reject());
        });
    }
    getAllByInstitution(data: any = {}) {
        return new Promise((resolve, reject) => {
            this.http.post("api/user-types/user-types/getAllByInstitution", true, data).then(res => {
                resolve(res);
            }).catch(err => reject());
        });
    }

    deleteUserType(data){
        return new Promise((resolve, reject) => {
            this.http.post("api/user-types/user-types/removeUserType", true, data).then(res => {
                resolve(res);
            }).catch(err => reject());
        })
    }
    setField(data: any) {
        return new Promise((resolve, reject) => {
            console.log(resolve);
            this.fields = data;
        }).catch(err => console.log("error"));
    }

    getFields() {
        return this.fields;
    }

    setNextData(data: any) {
        return new Promise((resolve, reject) => {
            this.dataNext = data;
        }).catch(err => console.log("error"));
    }

    getNextData() {
        return this.dataNext;
    }

}

